<template lang="pug">
  main
    NavBarTPA
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.has-text-dark
          .column.is-half.is-offset-one-quarter.has-text-centered.section-title
            h1.title Expediente de Descarga Actual  &nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
            .column.has-text-centered(v-show="permisos.monitoreo == 1 || permisos.monitoreo == 11")
              b.has-text-black(v-show="!showForm")
                a.button.is-dark.is-rounded(@click="showForm = true")
                  | Actualizar Archivo de Descarga Actual &nbsp&nbsp
                  span.icon
                    i.fas.fa-sync
            .column(v-show="showForm")
              .uploader(@dragenter='OnDragEnter' @dragleave='OnDragLeave' @dragover.prevent='' @drop='onDrop' :class='{ dragging: isDragging }')
                div
                  i.fas.fa-cloud-upload-alt.font-big
                  p Arrastra tus archivos aquí...
                  div ó
                  .field.has-addons.has-addons-centered
                    .file.is-small.is-black
                      label.file-label
                        input.file-input#file(type='file' @change='onInputChange' accept="application/pdf,application/vnd.ms-excel" multiple)
                        span.file-cta
                          span.file-icon
                            i.fas.fa-upload
                          span.file-label
                            | Seleccione un archivo...

        .columns(v-show="showForm")
          .column.is-half.is-offset-one-quarter.has-text-centered
            b.has-text-black(@click="showForm = false")
              a.button.is-light.is-rounded
                | &nbspCancelar
        .columns.has-text-dark
          .column.is-half
            ul
              li(v-for="f in filesEDA" :key="f.id")
                  a.button.is-text(v-show="checkPublicFile(f)" :href="f.ruta" target="_blank" ) {{ f.nombre }}
                    | &nbsp
                  a.button.is-rounded.is-small(:class="f.public == true ? 'is-success' : ''" v-show="permisos.monitoreo == 1" @click="changePublic(f)")
                    span.icon
                      i.fas.fa-eye
                  | &nbsp
                  a.button.is-danger.is-rounded.is-small(v-show="permisos.monitoreo == 1" @click="deleteFile(f)")
                    span.icon
                      i.fas.fa-trash
  </template>

  <script>
  import Loader from '@/components/shared/Loader.vue'
  import NavBarTPA from '@/components/layout/NavBarTPA.vue'
  import monitorServices from '@/services/sca/monitor'
  import { mapState } from 'vuex'

  export default {
    name: 'EDA',
    components: { Loader, NavBarTPA },
    data () {
      return {
        isLoading: false,
        showForm: false,
        formFile: {
          id: null,
          file: null,
          id_bt: null,
          public: null,
        },
        filesEDA: [],
        isDragging: false,
        dragCount: 0,
      }
    },
    methods: {
      inciarComponente() {
        this.obtenerEDA()
      },

      obtenerEDA () {
        monitorServices.getArchivosEDA()
          .then ( data => {
            this.$store.commit('setArchivosEDA', data)
            this.filesEDA = this.archivosEDA
            this.isLoading = false
          })
          .catch( e => {
            console.log(e)
          })
      },

      backPage() {
        this.$router.back()
      },

      OnDragEnter(e) {
        e.preventDefault()

        this.dragCount++
        this.isDragging = true
        return false
      },
      OnDragLeave(e) {
        e.preventDefault()
        this.dragCount--
        if (this.dragCount <= 0)
            this.isDragging = false
      },
      onInputChange(e) {
        console.log(e)
        const files = e.target.files
        Array.from(files).forEach(f => this.insertFile(f))
      },
      onDrop(e) {
        e.preventDefault();
        e.stopPropagation();
        this.isDragging = false;
        const files = e.dataTransfer.files
        Array.from(files).forEach(f => this.insertFile(f))
      },
      insertFile(file) {
        const form = {
          'file': file
        }
        monitorServices.insertFileEDA(form)
        .then( res => {
            const { success, data } = res
            if (success) {
              this.$store.commit('insertArchivoEDA', data)
              this.filesEDA = this.archivosEDA
              this.showForm = false
            }
          })
          .catch( e => {
            console.log(e)
          })
      },

      deleteFile(file) {
        monitorServices.deleteFileEDA(file)
          .then( res => {
            const { data } = res
            this.$store.commit('deleteArchivoEDA', data[0])
            this.filesEDA = this.archivosEDA
          })
          .catch( e => {
            console.log(e)
          })
      },

      changePublic(file) {
        this.isLoading = true
        const newStatus = !file.public

        monitorServices.changeStatusEDA(newStatus? 1:0)
          .then( res => {
            const { message } = res
            this.inciarComponente()
          })
          .catch( e => {
            console.log(e)
          })
      },

      checkPublicFile(file) {
        let visible = false
        visible = this.permisos.monitoreo == 1 || this.permisos.monitoreo == 11
        console.log("🚀 ~ checkPublicFile ~ visible:", visible)

        if (this.permisos.monitoreo == 12) {
          visible = file.public
          console.log("🚀 ~ checkPublicFile ~ visible:", visible)
        }

        return visible
      }
    },
    computed: {
      ...mapState(['logueado', 'userLogin', 'permisos', 'archivosEDA'])
    },
    created () {
      this.inciarComponente()
    },
  }
  </script>

<style lang="scss" scoped>

.image {
  display: inline-block;
}

.card:hover {
  transform: translateY(-5px) scale(1.005) translateZ(0);
  box-shadow: 0 24px 36px rgba(0,0,0,0.11), 0 14px 16px rgba(0,0,0,0.11);
}

.section-title {
  margin-top: 1rem;
  margin-bottom: 2rem;
}

.card {
  color: #54545c;
}
.uploader {
  width: 100%;
  background: whitesmoke;
  color: #363636;
  padding: 40px 15px;
  text-align: center;
  border-radius: 10px;
  border: 3px dashed #363636;
  font-size: 20px;
  position: relative;

  &.dragging {
    background: #363636;
    color: whitesmoke;
    border: 3px dashed #363636;
    // .file-input label {
    //   background: #363636;
    //   color: whitesmoke;
    // }
  }

  i.font-big {
    font-size: 85px;
  }

  .images-preview {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    .img-wrapper {
      width: 160px;
      display: flex;
      flex-direction: column;
      margin: 10px;
      height: 150px;
      justify-content: space-between;
      background: whitesmoke;
      box-shadow: 5px 5px 20px #363636;
      img {
        max-height: 105px;
      }
    }
    .details {
      font-size: 12px;
      background: #363636;
      color: whitesmoke;
      display: flex;
      flex-direction: column;
      align-items: self-start;
      padding: 3px 6px;
      .name {
        overflow: hidden;
        height: 18px;
      }
    }
  }
  .upload-control {

    button, label {
      cursor: pointer;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/sca_Componentes/monitor/ExpedienteDescarga.vue